import {
	DependencyList,
	RefObject,
	useEffect,
	useLayoutEffect,
	useRef
} from "react";

export const useEffectSkipFirstRender = (
	effect: () => void,
	deps: DependencyList
): void => {
	const isFirstRender: RefObject<boolean> = useRef<boolean>(true);

	useEffect(
		(): void => {
			if (!isFirstRender.current) {
				effect();
			}
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		deps
	);

	useEffect(
		() => {
			isFirstRender.current = false;
		},
		[]
	);

	useLayoutEffect(
		(): (() => void) => {
			return () => {
				isFirstRender.current = true;
			};
		},
		[]
	);
};